import React, { Component } from "react";
import { withRouter } from "react-router";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import {
  closeModalDialog,
  showSnackNotificationAction,
} from "../../../../actions/layoutActions";
import {
  performCreateRequest,
  setReload,
} from "../../../../actions/dataComponentActions";
import { getDataComponent } from "../../../../reducers/dataComponentReducer";
import { processCreateRequestStatus } from "../../../../utils/dataComponentUtils";
import ConsultingCompanyContactForm from "./ConsultingCompanyContactForm";
import SelectFromAddressBookForm from "./SelectFromAddressBookForm";
import { handleCreateContactError } from "../../VendorContacts/CreateVendorContact/CreateVendorContactFunctions";

const dataComponentId = "ConsultingCompanyContacts";

export class CreateConsultingCompanyContactContainer extends Component {
  state = {
    createNewContact: this.props.ignoreAddressBook,
    formikActions: undefined,
  };

  componentDidUpdate({ dataComponent: prevDataComponent }) {
    const { dataComponent, showSnackNotificationAction } = this.props;

    processCreateRequestStatus(prevDataComponent, dataComponent, {
      onSuccess: this.handleCreateRequestSuccess,
      onError: response =>
        handleCreateContactError(
          this.state.formikActions,
          showSnackNotificationAction
        )(response),
    });
  }

  handleCreateRequestSuccess = () => {
    const { closeModalDialog, setReload } = this.props;

    closeModalDialog();
    setReload(dataComponentId, true);
  };

  handleToggleCreateNewContact = () => {
    const { toggleCreateNewContact } = this.props;
    const next = !this.state.createNewContact;
    if (toggleCreateNewContact) {
      toggleCreateNewContact(next);
    }
    this.setState({ createNewContact: next });
  };

  handleCreateContact = (consultingCompanyContact, formikActions) => {
    const { performCreateRequest, addressBook } = this.props;

    if (consultingCompanyContact.contactId) {
      delete consultingCompanyContact.contact;
    }

    if (addressBook && addressBook.id) {
      performCreateRequest(dataComponentId, consultingCompanyContact, {
        addressBookId: addressBook.id,
      });
    } else {
      performCreateRequest(dataComponentId, consultingCompanyContact);
    }
    this.setState({ formikActions });
  };

  render() {
    const {
      consultingCompanyId,
      scopeId,
      consultingCompany,
      ignoreAddressBook,
    } = this.props;

    if (!this.state.createNewContact && !ignoreAddressBook) {
      return (
        <SelectFromAddressBookForm
          consultingCompany={
            consultingCompany || { id: consultingCompanyId, scopeId }
          }
          onSubmit={this.handleCreateContact}
          toggleCreateNewContact={this.handleToggleCreateNewContact}
        />
      );
    }

    return (
      <ConsultingCompanyContactForm
        sendButtonText="Create Contact"
        onSubmit={this.handleCreateContact}
        consultingCompanyContact={{
          contact: {
            person: {
              firstName: "",
              lastName: "",
              phoneNumber: "",
              faxNumber: "",
              email: "",
              scopeId,
            },
            jobTitle: "",
            scopeId,
          },
          consultingCompanyId,
          isActive: true,
        }}
        dataComponentId={dataComponentId}
      />
    );
  }
}

CreateConsultingCompanyContactContainer.propTypes = {
  closeModalDialog: PropTypes.func.isRequired,
  performCreateRequest: PropTypes.func.isRequired,
  setReload: PropTypes.func.isRequired,
  showSnackNotificationAction: PropTypes.func.isRequired,
  dataComponent: PropTypes.object,
  consultingCompanyId: PropTypes.string,
  scopeId: PropTypes.string,
  consultingCompany: PropTypes.object,
  addressBook: PropTypes.object,
  ignoreAddressBook: PropTypes.bool,
  toggleCreateNewContact: PropTypes.func,
};

CreateConsultingCompanyContactContainer.defaultProps = {
  ignoreAddressBook: false,
  addressBook: {},
};

const mapStateToProps = state => {
  const dataComponent = getDataComponent(dataComponentId, state);
  return { dataComponent };
};

const mapDispatchToProps = {
  setReload,
  closeModalDialog,
  performCreateRequest,
  showSnackNotificationAction,
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(CreateConsultingCompanyContactContainer)
);
